<template>
	<div class="mobile-menu-wrap">
		<div class="mobile-menu" @click="visibleSlide = !visibleSlide">
			<van-icon name="wap-nav" color="#ffffff" class="mobile-menu-icon" />
		</div>

		<van-popup v-model="visibleSlide" get-container="#app" position="right" style="width: 80%; height: 100%">
			<div class="menu-popup">
				<div class="menu-popup-main">
					<h3 @click="goMenu('home')">{{ $t('menu.home') }}</h3>
					<van-collapse v-model="activeNames" accordion :border="false">
						<van-collapse-item
							v-for="(item, index) in collapseData"
							:key="index"
							:title="item.title"
							:name="item.name"
							:border="false"
							:is-link="item.children.length > 0"
						>
							<template #title>
								<div class="slot-title" @click="goMenu(item.skipName)">
									<span>{{ item.title }}</span>
								</div>
							</template>
							<div v-if="item.children.length > 0" class="menu-collapse-wrap">
								<div
									v-for="(child, cIdx) in item.children"
									:key="cIdx"
									class="menu-collapse-item"
									@click="goMenu(child.skipName, child.id)"
								>
									{{ child.title }}
								</div>
							</div>
						</van-collapse-item>
					</van-collapse>
				</div>

				<div class="menu-popup-footer">
					<span>400-003-1233</span>
					<a href="tel:400-003-1233">{{ $t('contact.tel') }}</a>
				</div>
			</div>
		</van-popup>
	</div>
</template>

<script setup>
import { ref, defineExpose, onMounted } from 'vue';
import { MENU } from '@/utils/const';
import { getUuid, useRouter } from '@/utils/api';

const visibleSlide = ref(false);
const show = () => {
	visibleSlide.value = true;
};
const hide = () => {
	visibleSlide.value = false;
};

const activeNames = ref([]);
const collapseData = ref([]);
onMounted(() => {
	collapseData.value = MENU().filter(menu => menu.name !== 'home').map(menu => {
		const uuid = getUuid();
		return {
			title: menu.label,
			name: uuid,
			skipName: menu.name,
			children: (menu.children || []).map(childMenu => {
				const childUuid = getUuid();
				return {
					title: childMenu.label,
					name: childUuid,
					skipName: childMenu.name,
					id: childMenu.id
				};
			})
		};
	});
});

const router = useRouter();
const goMenu = (name, id = '') => {
	if (!name) return;
	const option = {
		name: name
	};
	if (id) option.hash = `#${id}`;
	router.push(option);
	hide();

	if (id) {
		//公司治理滚动到
		setTimeout(() => {
			let dom = document.querySelector(`#${id}`);
			if (!dom) return;
			window.scrollTo({
				top: dom.offsetTop,
				behavior: 'smooth'
			});
		}, 200);
	}
};

defineExpose({ show, hide });
</script>

<style lang="less">
.menu-popup {
	height: 100%;
	position: relative;

	.menu-popup-main {
		padding: 0 2.5rem;

		h3 {
			line-height: 7rem;
			font-size: 1.8rem;
			color: #0052a2;
			border-bottom: 0.1rem solid #f5f5f5;
		}
		.van-cell {
			padding: 0;
		}
		.van-cell {
			.van-cell__title,
			.slot-title {
				height: 5.4rem;
				line-height: 5.4rem;

				span {
					font-size: 1.5rem;
					color: #020202;
					font-family: 'SourceHanSansCN-Medium';
				}
			}
		}
		.van-cell > i {
			color: #020202;
			font-weight: 600;
		}
		.van-cell__right-icon {
			line-height: 5.4rem;
		}
		.van-collapse-item__content {
			position: relative;
			top: -0.5rem;
			padding: 0;
		}
		.menu-collapse-wrap {
			padding-left: 1.5rem;

			.menu-collapse-item {
				font-size: 1.2rem;
				color: #000;
				font-family: 'SourceHanSansCN-Normal';
				height: 3rem;
				line-height: 3rem;
				white-space: nowrap;
			}
		}
	}
	.menu-popup-footer {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		box-shadow: 0 0 0.5rem #888;
		padding: 2.5rem 2.65rem;

		display: flex;
		justify-content: space-between;
		z-index: 999;
		background-color: #fff;

		span {
			font-size: 1.8rem;
			color: #020202;
			font-family: 'SourceHanSansCN-Medium';
			line-height: 4rem;
		}
		a {
			display: block;
			width: 8.75rem;
			height: 3.45rem;
			border-radius: 2rem;
			line-height: 3.45rem;
			text-align: center;
			color: #f5f5f5;
			background-color: #0052a2;
			font-size: 1.5rem;
			font-family: 'SourceHanSansCN-Medium';
		}
	}
}
</style>
<style lang="less" scoped>
.mobile-menu-wrap {
	.mobile-menu {
		height: 100%;

		.mobile-menu-icon {
			font-size: 2.3rem;
		}
	}
}
</style>
